import { useContext, useMemo } from "react";
import PaymentContext from "../../../store/PaymentContext";
import { PaymentConst } from "../../../utils/payment";
import InvoiceRent from "./InvoiceRent";
import InvoiceSell from "./InvoiceSell";

const Invoice = ({ }: any) => {

    const { tabActiveStep1 }: any = useContext(PaymentContext)

    return Number(tabActiveStep1) === Number(PaymentConst.TabConst.rent) ? <InvoiceRent /> : <InvoiceSell />
}

export default Invoice;
